import { RISK_CENTER_TABS } from "../components/ui/shell/module-nav";

export const DEFAULT_IT_TAB = "dashboards";

export const IT_EXTRA_TAB_IDS = ["workflow-editor"];

export const IT_TAB_IDS = [
  ...RISK_CENTER_TABS.map((t) => t.id),
  ...IT_EXTRA_TAB_IDS,
];

export function isValidItTab(tab) {
  if (!tab) return false;
  return IT_TAB_IDS.includes(tab);
}

/**
 * Build a shareable IT module URL.
 * @param {string} tab
 * @param {{ department?: number|string, riskId?: number|string }} opts
 */
export function itPath(tab = DEFAULT_IT_TAB, { department, riskId } = {}) {
  const safeTab = isValidItTab(tab) ? tab : DEFAULT_IT_TAB;

  let path;
  if (riskId != null && riskId !== "" && safeTab === "dashboards") {
    path = `/IT/${safeTab}/${riskId}`;
  } else {
    path = `/IT/${safeTab}`;
  }

  const params = new URLSearchParams();
  if (department != null && department !== "") {
    params.set("department", String(department));
  }
  const qs = params.toString();
  return `${path}${qs ? `?${qs}` : ""}`;
}

/** Parse pathname + search into IT navigation state. */
export function parseItLocation({ pathname, search }) {
  const parts = pathname.split("/").filter(Boolean);

  if (parts[0] !== "IT") {
    return { tab: DEFAULT_IT_TAB, department: null, riskId: null };
  }

  const tab = parts[1] || DEFAULT_IT_TAB;
  let riskId = null;
  if (parts[1] === "dashboards" && parts[2]) {
    riskId = parts[2];
  }

  const params = new URLSearchParams(search || "");
  const deptRaw = params.get("department");
  const department = deptRaw ? parseInt(deptRaw, 10) : null;

  return {
    tab: isValidItTab(tab) ? tab : DEFAULT_IT_TAB,
    department: Number.isFinite(department) ? department : null,
    riskId,
  };
}
